import { Model, Q } from '@nozbe/watermelondb';
import {
  action,
  children,
  field,
  json,
  lazy,
} from '@nozbe/watermelondb/decorators';

import { Page } from '@src/database/models';
import { PrimePage } from '@src/types';

const sanitizeCategories = (categories: any) => {
  return Array.isArray(categories) ? categories.map(String) : [];
};

const sanitizeLabels = (labels: any) => {
  return Array.isArray(labels) ? labels.map(parseInt) : [];
};

// @ts-ignore
export default class Book extends Model {
  static table = 'books';
  static associations = {
    pages: { type: 'has_many', foreignKey: 'book_id' },
  };

  @field('title') title: string;
  @field('description') description: string;
  @field('publisher') publisher?: string;
  @field('cover_url') coverUrl?: string;
  @field('translator') translator?: string;
  @field('language') language: string;
  @field('pagesCount') pagesCount: number;
  @field('score') score: number;
  @field('scoreCount') scoreCount: number;
  @field('is_bookmarked') isBookmarked: boolean;
  @field('type') type: number;
  @field('status') status: number;
  @json('categories', sanitizeCategories) categories: string[];
  @json('labels', sanitizeLabels) labels: number[];
  @field('is_downloaded') isDownloaded: boolean;

  @children('pages') pages: any;
  // @ts-ignore
  @lazy downloadedPages = this.pages.extend(Q.where('is_downloaded', true));
  // @ts-ignore
  @lazy sortedPages = this.pages.extend(Q.experimentalSortBy('order', Q.asc));

  @action async addPages(primePages: PrimePage[]) {
    const pages = await Promise.all(
      primePages.map(async (primePage) => {
        return await this.collections
          .get<Page>(Page.table)
          .prepareCreate((page) => {
            page.book.set(this);
            page._raw.id = primePage.id;
            page.audio = primePage.audio?.source.uri;
            page.containedEntities = primePage.containedEntities;
            page.text = primePage.text;
            page.topic = primePage.topic;
            page.order = primePage.order;
            page.isDownloaded = false;
          });
      })
    );
    return await this.batch(...pages);
  }

  @action async setDownloaded(value: boolean) {
    await this.update((record) => {
      record.isDownloaded = value;
    });
  }
}
